module.exports = __webpack_public_path__ + "img/1ac716c.jpg";